import { useCallback } from "react";

import { useHistory, useParams } from "react-router-dom";
import { DashboardType } from "@doitintl/cmp-models";

import mixpanel from "../../utils/mixpanel";

export const isHomeDashboard = (dashboardName?: string): boolean => {
  const currentAndLegacyDashboardNames = ["default", "account", "home"];
  if (!dashboardName) {
    return false;
  }
  return currentAndLegacyDashboardNames.includes(dashboardName.toLowerCase());
};

export const useDashboardNavigation = () => {
  const history = useHistory();
  const { customerId } = useParams<{ customerId: string }>();

  return useCallback(
    (dashboardName: string) => {
      const normalizedDashboardName = dashboardName.replace(/\s+/g, "-").toLowerCase();

      if (normalizedDashboardName === DashboardType.GkeLensV2) {
        mixpanel.track("dashboards.gke-lens");
      }

      if (normalizedDashboardName === DashboardType.SnowflakeLens) {
        mixpanel.track("dashboards.snowflake-lens");
      }

      if (normalizedDashboardName === DashboardType.AWSMAPLens) {
        mixpanel.track("dashboards.map-lens");
      }

      const path = `/customers/${customerId}/dashboards/${dashboardName}`;

      if (dashboardName === "") {
        history.replace(path);
        return;
      }

      history.push(path);
    },
    [history, customerId]
  );
};
